import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="container page-container">
      <article className="page-card legal-page">
        <header className="page-card-header">
          <p className="page-eyebrow">Confidentialité</p>
          <h1>Politique de confidentialité</h1>
          <p className="page-lead">
            Dernière mise à jour : 21 août 2026
          </p>
        </header>

        <section>
          <h2>1. Responsable de la protection des renseignements personnels</h2>
          <p>
            Medcodes est responsable de la protection des renseignements personnels
            recueillis dans le cadre de l'utilisation de cette application. Pour
            toute question relative à cette politique ou à vos droits, vous pouvez
            nous joindre via le{' '}
            <Link to="/contact">formulaire de contact</Link>.
          </p>
        </section>

        <section>
          <h2>2. Portée</h2>
          <p>
            La présente politique s'applique à l'application Medcodes, un outil de
            préfacturation et de suivi d'activité destiné aux professionnels de la
            santé. Elle vise à vous informer, conformément aux exigences applicables
            au Québec, notamment la <em>Loi sur la protection des renseignements
            personnels dans le secteur privé</em>, des pratiques de Medcodes en
            matière de collecte, d'utilisation et de protection de vos renseignements.
          </p>
        </section>

        <section>
          <h2>3. Renseignements que nous recueillons</h2>
          <p>Nous recueillons uniquement les renseignements nécessaires au fonctionnement du service :</p>
          <ul>
            <li>Identité de compte : courriel, prénom et nom</li>
            <li>Identifiants de connexion : mot de passe (stocké sous forme chiffrée)</li>
            <li>Données d'activité professionnelle saisies dans l'application (transactions, codes, rapports)</li>
            <li>Données techniques minimales liées à la session (témoin de session)</li>
          </ul>
          <p>
            Medcodes ne recueille pas de renseignements personnels à des fins
            publicitaires, de profilage ou de revente à des tiers. Aucune information
            personnelle ou médicale n'est saisie sur l'application. Seuls des codes
            de facturation sont saisis et compilés sans aucune autre information associée.
          </p>
        </section>

        <section>
          <h2>4. Finalités de la collecte</h2>
          <p>Vos renseignements sont utilisés exclusivement pour :</p>
          <ul>
            <li>Créer et gérer votre compte utilisateur</li>
            <li>Vous authentifier de façon sécurisée</li>
            <li>Permettre la saisie, la conservation et l'affichage de vos données d'activité</li>
            <li>Assurer le bon fonctionnement, la sécurité et la maintenance de l'application</li>
            <li>Répondre à vos demandes de support</li>
          </ul>
        </section>

        <section>
          <h2>5. Témoins (cookies)</h2>
          <p>
            Medcodes utilise un témoin de session strictement nécessaire pour
            maintenir votre connexion. Ce témoin est fonctionnel et ne sert pas au
            suivi publicitaire. Aucune donnée personnelle n'est stockée dans ce
            témoin à des fins de marketing ou d'analyse comportementale.
          </p>
          <p>
            Un avis d'information sur les témoins vous est présenté lors de votre
            première visite. En cliquant sur « OK », vous reconnaissez avoir pris
            connaissance de cette utilisation.
          </p>
        </section>

        <section>
          <h2>6. Communication à des tiers et localisation des données</h2>
          <p>
            Medcodes ne vend ni ne loue vos renseignements personnels. Vos données
            sont hébergées et stockées exclusivement sur des serveurs situés au
            Canada. Elles peuvent être confiées à des fournisseurs d'infrastructure
            (par exemple, hébergement de serveur ou de base de données) agissant
            uniquement pour notre compte, au Canada, et soumis à des obligations de
            confidentialité et de sécurité raisonnables.
          </p>
        </section>

        <section>
          <h2>7. Conservation et sécurité</h2>
          <p>
            Vos renseignements sont conservés aussi longtemps que votre compte est
            actif ou que la loi l'exige. Toutes les données sont stockées sur des
            serveurs canadiens afin de garantir que vos renseignements demeurent
            au Canada. Nous appliquons des mesures de sécurité raisonnables, incluant
            le chiffrement des mots de passe et l'utilisation de connexions sécurisées
            en production.
          </p>
        </section>

        <section>
          <h2>8. Vos droits</h2>
          <p>
            Conformément à la législation québécoise, vous pouvez demander l'accès
            à vos renseignements personnels, leur rectification ou, lorsque
            applicable, leur suppression. Vous pouvez également retirer votre
            consentement pour certaines utilisations, sous réserve des obligations
            légales ou contractuelles de Medcodes.
          </p>
          <p>
            Pour exercer vos droits, utilisez le{' '}
            <Link to="/contact">formulaire de contact</Link>. Nous
            répondrons dans les délais prévus par la loi.
          </p>
        </section>

        <section>
          <h2>9. Modifications</h2>
          <p>
            Cette politique peut être mise à jour périodiquement. La date de la
            dernière mise à jour sera indiquée en haut de la page. Nous vous
            encourageons à la consulter régulièrement.
          </p>
        </section>

        <footer className="legal-page-footer">
          <Link to="/" className="btn btn-outline-primary">Retour à l'accueil</Link>
        </footer>
      </article>
    </div>
  );
};

export default PrivacyPolicy;
